<template>
    <ul class="product-variants list-unstyled">
        <li v-for="(variant, index) in variants" :key="'variant' + index" class="product-variant-item">
            <VariantItemFlat
                :variant="variant"
                :arrival-date="arrivalDate"
                :isVoucher="isValueVoucher"
                :isAuctionOffer="isAuctionOffer"
                @variantSelected="selectedVariant => $emit('variantSelected', selectedVariant)"
            >
            </VariantItemFlat>
        </li>
    </ul>
</template>

<script>
import VariantItemFlat from '@/components/product/selection/VariantItemFlat.vue';

/**
 * @typedef { import('../../../models/pre-ts/product/Variant').Variant } Variant
 */

/**
 *
 */

export default {
    name: 'VariantsList',
    components: {
        VariantItemFlat
    },
    props: {
        /**
         * @type Variant[]
         */
        variants: {
            type: Array,
            required: true
        },
        arrivalDate: {
            type: String
        },
        isValueVoucher: Boolean,
        isAuctionOffer: Boolean
    }
};
</script>

<style scoped lang="scss">
.product-variants {
    background-color: var(--product-select-variant-bg);
    margin-bottom: 0;
}
</style>
